<template>
  <main class="body" role="main" id="main">
    <sc-placeholder tag="section" :rendering="rendering" name="locations-list-layout"/>
  </main>
</template>

<script>

  import UIMixin from '~/mixins/ui'

  import { Placeholder } from '@sitecore-jss/sitecore-jss-vue'

  export default {
    name: 'LocationsPage',
    authenticated: true,
    props: {
      rendering: {
        type: Object
      }
    },
    components: {
      scPlaceholder: Placeholder
    },
    mixins: [
      UIMixin
    ]
  }
</script>

<style lang="scss" scoped>

</style>
